import moment from "moment";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import CustomDataTable from "../../Components/CustomDataTable";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import PostApiCall from "../../Api/Api";
import { useSelector } from "react-redux";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import { Badge, Card, CardBody } from "reactstrap";

const WalletHistory = () => {
  const user = useSelector((state) => state.login);
  const [walletHistory, setWalletHistory] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);

  const columnDefs = [
    {
      field: "fld_transactiontype",
      header: "Type",
      sortable: true,
      body: (rowData) => (
        <span
          className={`rounded-3 px-2 text-white`}
          style={{
            backgroundColor:
              rowData.fld_transactiontype === "CREDIT"
                ? "#28a745"
                : rowData.fld_transactiontype === "DEBIT"
                ? "#dc3545"
                : "#17a2b8",
            fontSize: "12px",
          }}
        >
          {rowData.fld_transactiontype}
        </span>
      ),
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "120px", fontSize: "13px" },
    },
    {
      field: "fld_amount",
      header: "Amount",
      sortable: true,
      body: (rowData) => `₹${Number(rowData.fld_amount).toFixed(2)}`,
      headerStyle: { width: "130px", minWidth: "130px", fontSize: "13px" },
      bodyStyle: { minWidth: "130px", fontSize: "13px" },
    },
    {
      field: "fld_previousbalance",
      header: "Previous Balance",
      sortable: true,
      body: (rowData) =>
        `₹${Number(rowData.fld_previousbalance).toFixed(2)}`,
      headerStyle: { width: "160px", minWidth: "160px", fontSize: "13px" },
      bodyStyle: { minWidth: "160px", fontSize: "13px" },
    },
    {
      field: "fld_currentbalance",
      header: "Current Balance",
      sortable: true,
      body: (rowData) =>
        `₹${Number(rowData.fld_currentbalance).toFixed(2)}`,
      headerStyle: { width: "160px", minWidth: "160px", fontSize: "13px" },
      bodyStyle: { minWidth: "160px", fontSize: "13px" },
    },
    {
      field: "fld_referenceid",
      header: "Reference",
      sortable: true,
      body: (rowData) => rowData.fld_referenceid || "-",
      headerStyle: { width: "150px", minWidth: "150px", fontSize: "13px" },
      bodyStyle: { minWidth: "150px", fontSize: "13px" },
    },
    {
      field: "fld_description",
      header: "Description",
      sortable: true,
      body: (rowData) => rowData.fld_description || "-",
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_status",
      header: "Status",
      sortable: true,
      body: (rowData) => (
        <span
          className={`rounded-3 px-2 text-white`}
          style={{
            backgroundColor:
              rowData.fld_status === "SUCCESS"
                ? "#28a745"
                : rowData.fld_status === "FAILED"
                ? "#dc3545"
                : "#ffc107",
            fontSize: "12px",
            color:
              rowData.fld_status === "PENDING" ? "#212529" : "#ffffff",
          }}
        >
          {rowData.fld_status}
        </span>
      ),
      headerStyle: { width: "120px", minWidth: "120px", fontSize: "13px" },
      bodyStyle: { minWidth: "120px", fontSize: "13px" },
    },
    {
      field: "fld_createdat",
      header: "Date",
      sortable: true,
      body: (rowData) =>
        moment(rowData?.fld_createdat).format("DD MMM YYYY, hh:mm A") || "",
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
  ];

  useEffect(() => {
    (async () => {
      Notiflix.Loading.standard();
      try {
        const res = await PostApiCall.postRequest(
          { userid: user?.fld_id },
          "GetJobAuditorWalletHistory"
        );
        const { data } = await res.json();

        if (res.status === 200) {
          setWalletHistory(data || []);
          // Get current balance from the latest transaction
          if (data && data.length > 0) {
            setWalletBalance(data[0].fld_currentbalance);
          } else {
            setWalletBalance(0);
          }
        } else {
          throw new Error(data?.message || "Failed to fetch wallet history");
        }
        Notiflix.Loading.remove();
      } catch (error) {
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    })();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
        <h5 style={{ color: PRIMARY_TEXT_COLOR }}>My Wallet</h5>
      </div>

      {/* Balance Card */}
      <div
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "12px",
          padding: "24px",
          color: "white",
          marginBottom: "20px",
          marginTop: "10px",
        }}
      >
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <p style={{ margin: 0, fontSize: "14px", opacity: 0.8 }}>
              Wallet Balance
            </p>
            <h2
              style={{
                margin: "8px 0 0 0",
                fontSize: "32px",
                fontWeight: "bold",
              }}
            >
              ₹{Number(walletBalance || 0).toFixed(2)}
            </h2>
          </div>
          <div>
            <span
              className="rounded-3 px-3 py-1"
              style={{
                backgroundColor:
                  walletBalance > 0
                    ? "rgba(255,255,255,0.2)"
                    : "rgba(255,255,255,0.1)",
                fontSize: "13px",
                fontWeight: "600",
              }}
            >
              {walletBalance > 0 ? "ACTIVE" : "NO BALANCE"}
            </span>
          </div>
        </div>
        <div className="mt-3 d-flex" style={{ gap: "20px", fontSize: "13px", opacity: 0.8 }}>
          <span>
            Total Transactions: {walletHistory.length}
          </span>
          {walletHistory.length > 0 && (
            <span>
              Last Transaction:{" "}
              {moment(walletHistory[0]?.fld_createdat).format("DD MMM YYYY")}
            </span>
          )}
        </div>
      </div>

      {/* Transaction History Table */}
      <div className="mt-2" style={{ minHeight: "400px" }}>
        <CustomDataTable
          data={walletHistory}
          columns={columnDefs}
          compact={true}
        />
      </div>
    </div>
  );
};

export default WalletHistory;
